import { render, staticRenderFns } from "./InventoryReportsList.vue?vue&type=template&id=24cdc462&scoped=true&"
import script from "./InventoryReportsList.vue?vue&type=script&lang=js&"
export * from "./InventoryReportsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cdc462",
  null
  
)

export default component.exports